import { AfterViewInit, Component, Inject, OnDestroy, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { FileLogger, Tools } from "@comunicare/comunicare-helper";
import { IQuestionnaireResponse } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { TPDAsService } from "../../tpdas.service";
import { QRDataSource } from "./qr.datasource";

@Component({
  selector: "app-qr-modal",
  templateUrl: "./qr-modal.component.html",
  styleUrls: ["./qr-modal.component.scss"],
})
export class QuestionnaireResponseModalComponent implements AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatTable) table: MatTable<IQuestionnaireResponse>;

  public datasource: QRDataSource = new QRDataSource();
  public displayedColumns: string[] = ["modified", "questionnaire", "user", "actions"];
  public isDownloading = false;

  private onDestroy$ = new Subject<void>();

  constructor(
    private tpdaService: TPDAsService,
    private translateService: TranslateService,
    private snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA)
    public data: { QRs: IQuestionnaireResponse[]; TPDAId: string }
  ) {
    this.datasource.loadData(this.data.QRs);
  }

  ngAfterViewInit(): void {
    this.initPaginatorAndSort();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private initPaginatorAndSort(): void {
    this.datasource.sort = this.sort;
    this.datasource.paginator = this.paginator;
  }

  public async downloadQRs(qr: IQuestionnaireResponse): Promise<void> {
    this.isDownloading = true;
    this.snackbar.open(this.translateService.instant("export.message"), "ok", { duration: 3000 });
    try {
      const blob = await this.tpdaService.getTPDAQRsPDFs(this.data.TPDAId, qr.subject.reference, qr.identifier.value);
      const url = URL.createObjectURL(blob);
      Tools.downloadBlob(blob, url.split("/")[url.split("/").length - 1]);
    } catch (err) {
      FileLogger.error("TPDA Participant modal", "downloadQRs()", err);
      this.snackbar.open(this.translateService.instant("api.errors.unknowerror"), undefined, {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    }
    this.isDownloading = false;
  }
}
